import { render, staticRenderFns } from "./DriversTableWidget.vue?vue&type=template&id=462b1d15&"
import script from "./DriversTableWidget.vue?vue&type=script&lang=js&"
export * from "./DriversTableWidget.vue?vue&type=script&lang=js&"
import style0 from "./DriversTableWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports